/**
 * Форматирование для нового визуального слоя.
 *
 * Существует отдельно от `lib/format.ts`, потому что тот принимает `TFunction` и
 * собирает строки через i18n. Новый слой сознательно русскоязычный: панель
 * делается для одного владельца, и таскать пару ru/en через каждую подпись
 * дороже, чем потом один раз извлечь строки, если понадобится второй язык.
 * Числовые же форматы от языка не зависят вообще.
 */

/** `3д 04ч`, `12ч 36м`, `41м`, `—`. */
export function uptimeOf(startedAt: string | null | undefined, now = Date.now()): string | null {
  if (startedAt === null || startedAt === undefined) return null
  const started = Date.parse(startedAt)
  if (Number.isNaN(started)) return null
  const minutes = Math.max(0, Math.floor((now - started) / 60_000))
  const days = Math.floor(minutes / 1440)
  const hours = Math.floor((minutes % 1440) / 60)
  const rest = minutes % 60
  if (days > 0) return `${days}д ${pad(hours)}ч`
  if (hours > 0) return `${hours}ч ${pad(rest)}м`
  return `${rest}м`
}

/** `120 / 64 / -311` — целые числа: дробные координаты в списке только шумят. */
export function coordsOf(
  pos: { x: number; y: number; z: number } | null | undefined
): string | null {
  if (pos === null || pos === undefined) return null
  return `${Math.round(pos.x)} / ${Math.round(pos.y)} / ${Math.round(pos.z)}`
}

/** `14:03:22` — время строки лога, всегда локальное. */
export function clockOf(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

/** `18.06.2026, 21:40` — дата целиком, для «токен валиден до». */
export function dateTimeOf(iso: string | null | undefined): string | null {
  if (iso === null || iso === undefined) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' })
}

/** `512 МБ`, `1.4 ГБ` — байты уже в мегабайтах. */
export function megabytesOf(mb: number): string {
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} ГБ` : `${Math.round(mb)} МБ`
}

function pad(value: number): string {
  return value.toString().padStart(2, '0')
}
